import React from 'react';
import { Button } from 'reactstrap';

import ParagraphWithHeading from '../../components/ParagraphWithHeading';
import Text from '../../components/Text';
import { createParagraphs } from '../../utils/textHelpers';

import './LegalTerms.scss';

const onBackButtonClicked = ({ history }) => {
  history.goBack();
};

export default function LegalTermss(props) {
  const hideElement = props.renderContentOnly === 'true' ? 'hide' : '';

  return (
    <>
      <Button
        className={`backButton ${hideElement}`}
        color="success"
        onClick={() => {
          onBackButtonClicked(props);
        }}
      >
        <Text value="Go Back" />
      </Button>
      <ParagraphWithHeading heading={props.pageHeading} body={props.summary} />
      {createParagraphs(props.content)}
      <Button
        className={`backButton ${hideElement}`}
        color="success"
        onClick={() => {
          onBackButtonClicked(props);
        }}
      >
        <Text value="Go Back" />
      </Button>
    </>
  );
}
